import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "certificate"
const CertificateIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18 9.375C20.485 9.375 22.5 11.39 22.5 13.875 22.5 15.207 21.92 16.405 21 17.228V22.5L18 21 15 22.5V17.228C14.08 16.404 13.5 15.208 13.5 13.875 13.5 11.39 15.515 9.375 18 9.375M18 12C16.965 12 16.125 12.84 16.125 13.875S16.965 15.75 18 15.75 19.875 14.91 19.875 13.875 19.035 12 18 12"
            clipRule="evenodd"
          />
          <path d="M18.75 1.5C19.993 1.5 21 2.507 21 3.75V8.68C20.536 8.41 20.032 8.2 19.5 8.063V3.75C19.5 3.336 19.164 3 18.75 3H3.75C3.336 3 3 3.336 3 3.75V15.75C3 16.164 3.336 16.5 3.75 16.5H12.606C12.844 16.987 13.146 17.438 13.5 17.84V18H3.75C2.507 18 1.5 16.993 1.5 15.75V3.75C1.5 2.507 2.507 1.5 3.75 1.5z" />
          <path d="M11.25 9.75H4.5V8.25H11.25zM15 6.75H4.5V5.25H15z" />
        </svg>
      }
    </span>
  )
}
export default CertificateIcon
